import { AppAction } from 'actions/types/ActionTypes'
import { API_CALL } from 'actions/actionConstants'
import requestGetApprovalPolicy from 'businessTraveller/api/requestGetApprovalPolicy'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

interface Params {
  refetch?: boolean
}

const pendingApprovalPolicyRequestKeys = new Set<string>()

function fetchBusinessApprovalPolicy(
  businessId: string,
  params?: Params,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const policy = state.businessTraveller.businessApprovalPolicy.policy
    const currentBusinessUser = state.businessTraveller.currentBusinessAccount?.employee
    const approvalPolicyV2Enabled = !!state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.lebtApprovalPolicyV2]
    const requestKey = currentBusinessUser ? `${businessId}:${currentBusinessUser.id}:${approvalPolicyV2Enabled}` : undefined

    const shouldFetch = currentBusinessUser && requestKey && !pendingApprovalPolicyRequestKeys.has(requestKey) && (!policy || params?.refetch)
    if (shouldFetch) {
      pendingApprovalPolicyRequestKeys.add(requestKey)
      dispatch({
        type: API_CALL,
        api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_BUSINESS_APPROVAL_POLICY,
        request: () => requestGetApprovalPolicy({
          businessId,
          employeeId: currentBusinessUser.id,
          approvalPolicyV2Enabled,
        })
          .finally(() => {
            pendingApprovalPolicyRequestKeys.delete(requestKey)
          }),
      })
    }
  }
}

export default fetchBusinessApprovalPolicy
